import React, { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@material-ui/core";
import { graphQLApiService } from "../../../services/GraphQLApiService";
import { GET_REGIONS_AND_CITIES } from "../../../queries/prediction/destinationQuery";
import { formatISO } from "date-fns";
import { GET_TRIP_ANALYTICS_META } from "../../../queries/prediction/tripAnalyticsQuery";
import { useTranslation } from "react-i18next";

interface DestinationSelectProps {
  selectionRange: any;
  // eslint-disable-next-line no-unused-vars
  countryChange?: (val: string) => void;
  // eslint-disable-next-line no-unused-vars
  citiesChange?: (val: string[]) => void;
}

const DestinationSelect = ({
  selectionRange,
  countryChange,
  citiesChange,
}: DestinationSelectProps) => {
  const { t } = useTranslation();

  const [countries, setCountries] = useState<any[]>([]);
  const [cities, setCities] = useState<string[]>([]);

  useEffect(() => {
    graphQLApiService
      .query(GET_TRIP_ANALYTICS_META, {
        startDate: formatISO(selectionRange[0]?.startDate).split("T")[0],
        endDate: formatISO(selectionRange[0]?.endDate).split("T")[0],
      })
      .then((result: any) => {
        const countriesFromData =
          result?.data?.tripAnalytics?.countries?.nodes || [];
        setCountries(
          countriesFromData.map((item) => ({
            value: item.countryCode,
            label: item.name,
          }))
        );
      });
  }, [selectionRange]);

  const countryChanged = (country: any) => {
    setCities([]);

    if (countryChange) {
      countryChange(country);
    }

    if (country) {
      graphQLApiService
        .query(GET_REGIONS_AND_CITIES, {
          startDate: formatISO(selectionRange[0]?.startDate).split("T")[0],
          endDate: formatISO(selectionRange[0]?.endDate).split("T")[0],
          countryCode: country,
        })
        .then((result: any) => {
          const citiesFromData =
            result.data.tripAnalytics?.country?.region?.cities?.nodes || [];
          setCities(citiesFromData.map((item) => item.name));
        });
    } else {
      setCities([]);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <div>
        <Autocomplete
          disablePortal
          options={countries}
          getOptionLabel={(option) => option.label}
          defaultValue={{ value: "GR", label: "Greece" }}
          sx={{
            mr: 3,
            width: "300px",
            backgroundColor: "#fff",
            borderRadius: "20px",
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{ "& input": { color: "#919eab" } }}
              variant="outlined"
              label={t(`main.country`)}
            />
          )}
          onChange={(_, val: any) => countryChanged(val?.value)}
        />
      </div>
      <div>
        {cities.length > 0 && (
          <Autocomplete
            multiple
            disablePortal
            options={cities}
            defaultValue={cities}
            sx={{
              mr: 3,
              width: "300px",
              backgroundColor: "#fff",
              borderRadius: "20px",
            }}
            renderInput={(params) => (
              <TextField {...params} label={t(`main.cities`)} />
            )}
            onChange={(_, val: string[]) => citiesChange?.(val)}
          />
        )}
      </div>
    </Box>
  );
};

export default DestinationSelect;
